import React from "react";
import { Helmet } from "react-helmet";

const WithdrawSEO = () => {
  return (
    
    <Helmet>
            {/* Page title optimized for the withdrawal page */}
            <title>Betpro Plus Withdrawal - Fast & Secure Withdrawals</title>
    
            <link rel="icon" href="https://betprowallet.pk/favicon.ico" />
    
            {/* Canonical tag */}
            <link rel="canonical" href="https://betprowallet.pk/withdraw" />
    
            {/* Meta description focusing on withdrawing funds from Betpro Plus */}
            <meta name="description" content="Withdraw your winnings quickly and securely from your Betpro Plus account. ⚽️ Fast, reliable, and hassle-free withdrawal process with multiple payout options. Start withdrawing at Betprowallet.pk." />
    
            {/* Meta keywords for search engine optimization */}
            <meta name="keywords" content="Betpro Plus withdrawal, fast withdrawals, secure withdrawals, withdraw winnings, Betpro Plus payout options, online betting withdrawals, Betprowallet.pk withdrawal" />
    
            {/* Meta author */}
            <meta name="author" content="Betpro Plus" />
    
            {/* Open Graph meta tags for social media sharing */}
            <meta property="og:title" content="Betpro Plus Withdrawal - Fast & Secure Withdrawals" />
            <meta property="og:description" content="Withdraw your winnings quickly and securely from Betpro Plus. Choose from multiple payout options for a fast, secure, and hassle-free withdrawal experience at Betprowallet.pk." />
            <meta property="og:url" content="https://betprowallet.pk/withdraw" />
            <meta property="og:type" content="website" />
            <meta property="og:image" content="https://betprowallet.pk/bpthumb1.jpg" />
    
            {/* Twitter Card for sharing on Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="Betpro Plus Withdrawal - Fast & Secure Withdrawals" />
            <meta name="twitter:description" content="Withdraw your winnings quickly and securely from Betpro Plus. Fast, reliable, and multiple payout options available at Betprowallet.pk." />
            <meta name="twitter:image" content="https://betprowallet.pk/bpthumb1.jpg" />
    
            {/* Structured Data for SEO */}
            <script type="application/ld+json">
              {`
          {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Betpro Plus Withdrawal - Fast & Secure Withdrawals",
            "url": "https://betprowallet.pk/withdraw",
            "description": "Withdraw your winnings securely from your Betpro Plus account. Enjoy fast payouts with multiple options for a hassle-free experience.",
            "publisher": {
              "@type": "Organization",
              "name": "Betpro Plus"
            }
          }
        `}
            </script>
          </Helmet>
    

  );
};

export default WithdrawSEO;
